import Vue from "vue";
import "core-js/stable";
import "regenerator-runtime/runtime";
import { Switch } from "@coreui/vue";
import App from "./App.vue";
import router from "./imports/router";
import store from "./store";
import defineRulesFor from "./imports/ability";
import EventBus from "./imports/event-bus";

import "./imports/helpers";
import "./imports/http";
import "./imports/auth";
import "./imports/filters";
import "./imports/fontawesome";
import "./imports/libraries";

import AppCrud from "./imports/crud";
import AppForm from "./imports/form";

Vue.config.productionTip = false;
Vue.config.warnHandler = (msg, instance, trace) =>
  !["Avoid mutating a prop directly"].some((warning) => msg.includes(warning)) &&
  console.warn("[Vue warn]: ".concat(msg).concat(trace));

window.AppCrud = AppCrud;
window.AppForm = AppForm;

Vue.component("CoreSwitch", Switch);
Vue.component("JobObject", require("./components/objects/Job").default);
Vue.component("MessageObject", require("./components/objects/Message").default);
Vue.component("CustomerObject", require("./components/objects/Customer").default);
Vue.component("AppointmentObject", require("./components/objects/Appointment").default);
Vue.component("UserObject", require("./components/objects/User").default);
Vue.component("InvoiceObject", require("./components/objects/Invoice").default);
Vue.component("UnavailabilityObject", require("./components/objects/Unavailability").default);
Vue.component("PdfObject", require("./components/objects/PDF").default);
Vue.component("FileObject", require("./components/objects/File").default);
Vue.component("GenericObject", require("./components/objects/Generic").default);
Vue.component("NotesObject", require("./components/objects/Notes").default);

Vue.component("PhoneNumber", require("./components/common/PhoneNumber.vue").default);
Vue.component("FollowUpDice", require("./components/common/FollowUpDice.vue").default);
Vue.component("EntityActionSet", require("./components/common/EntityActionSet.vue").default);
Vue.component(
  "EntityDeleteControl",
  require("./components/common/EntityDeleteControl.vue").default
);
Vue.component("EntityEditControl", require("./components/common/EntityEditControl.vue").default);

Vue.component("FormAddress", require("./components/form/Address.vue").default);
Vue.component("FormCustomerSelect", require("./components/form/CustomerSelect.vue").default);
Vue.component("FormContactSelect", require("./components/form/ContactSelect.vue").default);
Vue.component("FormEmail", require("./components/form/Email.vue").default);
Vue.component("FormPassword", require("./components/form/Password.vue").default);
Vue.component("FormRadio", require("./components/form/Radio.vue").default);
Vue.component("FormBootstrapRadio", require("./components/form/BootstrapRadio.vue").default);
Vue.component("FormSelect", require("./components/form/Select.vue").default);
Vue.component("FormText", require("./components/form/Text.vue").default);
Vue.component("FormTextarea", require("./components/form/Textarea.vue").default);
Vue.component("FormJobSelect", require("./components/form/JobSelect.vue").default);
Vue.component("FormUserSelect", require("./components/form/UserSelect.vue").default);
Vue.component("FormDate", require("./components/form/Date.vue").default);
Vue.component("FormTime", require("./components/form/Time.vue").default);
Vue.component(
  "FormServiceTypesSelect",
  require("./components/form/ServiceTypesSelect.vue").default
);
Vue.component(
  "FormUserCoreComplianceViolationsSelect",
  require("./components/form/UserCoreComplianceViolationsSelect.vue").default
);
Vue.component("FormValidationAlert", require("./components/form/ValidationAlert.vue").default);
Vue.component("FormDesignationSelect", require("./components/form/DesignationSelect.vue").default);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  components: { App },
  router,
  store,
  data() {
    return {
      isRouterAlive: true,
    };
  },
  mounted() {
    // Detect double ESC tap to hide toastr
    function createCheckKeyPressFunction() {
      let timeout;
      let escTime = 0;
      function checkKeyPressed(event) {
        if (event.key === "Escape") {
          window.clearTimeout(timeout);
          escTime += 1;
          timeout = window.setTimeout(() => {
            escTime = 0;
          }, 1000);
        }
        if (escTime === 2) {
          window.toastr.remove();
          escTime = 0;
        }
      }
      return checkKeyPressed;
    }
    let checkKeyPressed = createCheckKeyPressFunction();
    window.addEventListener("keydown", checkKeyPressed, false);

    EventBus.$on("appointment-created", () => {
      this.$store.dispatch("achievement/fetch");
    });
    EventBus.$on("appointment-deleted", () => {
      this.$store.dispatch("achievement/fetch");
    });

    this.$auth.load().then(() => {
      if (this.$auth.check()) {
        this.$store.dispatch("achievement/init");
      }

      this.$ability.update(defineRulesFor(this.$auth.user() || {}));
    });
  },
  methods: {
    reload() {
      // @see https://www.zhihu.com/question/49863095/answer/289157209
      // Force router to re-initialise but not full page reload
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },

    setTitle(title) {
      document.title = title;
    },
  },

  template: '<App :is-router-alive="isRouterAlive" v-if="$auth.ready" />',
});
